// extracted by mini-css-extract-plugin
export default {"title":"game_title__fdBGG","subtitle":"game_subtitle__hLv8j","grid":"game_grid__xQhNA","cell":"game_cell__QTHoO"};